import { meetingsSelectors } from '@lifesize/nucleus';
import _get from 'lodash/get';
import { connect } from 'react-redux';
import { Global } from 'state/Global';
import actions from '../../actions/maxInactiveDaysActions';
import MaxInactiveDays from '../../components/Meetings/MeetingsTab/MaxInactiveDays/MaxInactiveDays';
import { isBusyFetchingMeetingsToDelete } from '../../selectors/maxInactiveDaysSelector';

const mapStateToProps = (state: Global) => {
  const maxInactiveDaysNucleusState = meetingsSelectors.maxInactiveDaysSelector(state);
  const nucleusIsBusy = _get(maxInactiveDaysNucleusState, 'isMaxInactiveDaysBusy', false);
  const graphQlIsBusy = isBusyFetchingMeetingsToDelete(state);

  return {
    isMaxInactiveDaysBusy: nucleusIsBusy || graphQlIsBusy,
    maxInactiveDays: _get(maxInactiveDaysNucleusState, 'maxInactiveDays', 0),
    maxInactiveDaysError: _get(maxInactiveDaysNucleusState, 'error', null)
  };
};

const mapDispatchToProps = (dispatch: Function) => ({
  getInactiveDays: () => {
    dispatch(actions.getInactiveDays());
  },
  handleOpenConfirmExpiration: async (payload: object) => {
    dispatch(actions.getItemsToBeDeleted(payload));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MaxInactiveDays);
